import { useSessionTree } from '@services/session'
import { Select, SelectProps } from '@shared/Form/Select'
import { isNil } from 'ramda'
import { useTranslation } from 'react-i18next'

type Props = SelectProps & {
  parentId?: number
}

export const SessionChildrenSelect = ({
  supportAll,
  ...props
}: Props & { supportAll?: boolean }) => {
  const { t } = useTranslation()

  const { parentId, notFoundContent = '請先選擇上層圖層', ...others } = props

  const { byId, loading } = useSessionTree()

  return (
    <Select
      loading={loading}
      notFoundContent={isNil(parentId) ? notFoundContent : undefined}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) => {
        if (typeof option?.children !== 'string') {
          return false
        }
        const labelValue = option.children as string
        return labelValue.includes(input)
      }}
      {...others}>
      {!!parentId ? (
        <>
          {supportAll && (
            <Select.Option value={-1} key={0}>
              {t('common:all')}
            </Select.Option>
          )}
          {byId[parentId]?.children.map((x: any) => (
            <Select.Option key={x.id} value={x.id}>
              {x.name}
            </Select.Option>
          ))}
        </>
      ) : null}
    </Select>
  )
}

export default SessionChildrenSelect
